import moment from 'moment';

export function formatTimestamp(timestamp, format, unix = false) {
  const date = unix ? moment(timestamp) : moment.unix(timestamp);

  const utc = moment.utc(date);

  return utc.local().format(format);
}

export function formatCustomDate(date, format) {
  return moment(date, format);
}

/**
 * @param {string} [n] phoneNumber
 * @return {string} a formatted phone number
 */
export function formatPhoneNumber(phoneNumber) {
  // Filter out phone numbers with country codes other than +1
  if (
    !phoneNumber ||
    phoneNumber.startsWith('+1-') ||
    (phoneNumber.startsWith('+') && !phoneNumber.startsWith('+1'))
  ) {
    return phoneNumber;
  }
  // It's a US/Canada number; let's format it.
  const cleaned = ('' + phoneNumber).replace(/\D/g, '');
  const match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return ['+1 (', match[2], ') ', match[3], '-', match[4]].join('');
  }
  return null;
}

export function formatEventDate(event) {
  if (!event) return '';
  const parts = [];
  if (event.isMultiDay) {
    if (event.day) parts.push(event.day);
    const dateStr = [event.month?.toUpperCase(), event.listDates]
      .filter(Boolean)
      .join(' ');
    if (dateStr) parts.push(dateStr);
    if (event.year) parts.push(event.year);
  } else {
    if (event.day) parts.push(event.day);
    if (event.date) parts.push(event.date);
    if (event.year) parts.push(event.year);
  }
  return parts.join(' - ');
}

export function formatTimestampEST(date) {
  const purchase_date = moment(date);
  const momentInSpecificTimezone = purchase_date.tz('America/New_York');
  return (
    momentInSpecificTimezone.format('MMM DD - YYYY h:mm A').toUpperCase() +
    ' EST'
  );
}
